import { render } from "./BlockActionMasse.vue?vue&type=template&id=0309a39c"
import script from "./BlockActionMasse.vue?vue&type=script&lang=js"
export * from "./BlockActionMasse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__